// import { handleActions } from 'redux-actions';
import {
  SET_USER_VALUE,
  FETCH_USER_LOADING,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  POST_USER_LOADING,
  POST_USER_SUCCESS,
  POST_USER_FAILED,
  CREATE_NEW_USER,
} from '../actions/userActions';

const initialValue = {
  loading: false,
};

// const users = handleActions({
//  [SET_USER_VALUE]: (state, action) => ({ ...state, ...action.payload }),
//  [FETCH_USER]: (state, action) => ({ ...action.payload }),
// }, initialValue);

// export default users;

export default function (state = initialValue, action) {
  switch (action.type) {
    case CREATE_NEW_USER:
      return { ...initialValue };
    case SET_USER_VALUE:
      return { ...state, ...action.payload };
    // FETCH USER
    case FETCH_USER_LOADING:
      return { ...state, loading: true };
    case FETCH_USER_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case FETCH_USER_FAILED:
      return { ...state, loading: false, error: action.payload };
    // POST USER
    case POST_USER_LOADING:
      return { ...state, loading: true };
    case POST_USER_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case POST_USER_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export const getUser = state => state.user;
export const getUserStatus = state => state.user.loading;
export const getUserError = state => state.user.error;
